<i [ngClass]="classes | async"></i>
